import { render, staticRenderFns } from "./Galeri.vue?vue&type=template&id=addd77dc&"
import script from "./Galeri.vue?vue&type=script&lang=js&"
export * from "./Galeri.vue?vue&type=script&lang=js&"
import style0 from "./Galeri.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports